import { render, staticRenderFns } from "./SearchWatchList.vue?vue&type=template&id=d25cc754&"
import script from "./SearchWatchList.vue?vue&type=script&lang=js&"
export * from "./SearchWatchList.vue?vue&type=script&lang=js&"
import style0 from "./SearchWatchList.vue?vue&type=style&index=0&id=d25cc754&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports